import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './layout/main/main.component';
import { AuthComponent } from './layout/auth/auth.component';
import { InvoicePayoutComponent } from './shared/components/invoice-payout/invoice-payout.component';
import { AuthGuardFxn } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AuthComponent,
    canActivate: [AuthGuardFxn],
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./pages/auth/auth-routes').then((m) => m.routes)
      }
    ]
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuardFxn],
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/after-login-page/pages-routes').then((m) => m.routes)
      }
    ]
  },
  {
    path: 'super-admin/invoice-payout',
    component: InvoicePayoutComponent
  }
];

RouterModule.forRoot(routes, {
  scrollPositionRestoration: 'enabled'
});